export interface Chapter {
  id: string;
  mangaId: string;
  index: number;
  title: string;
  publishedAt: string;
  views: string;
  content: string[];
}

export const hitmanChapters: Chapter[] = [
  {
    id: "chap-hr-001",
    mangaId: "hitman-reborn",
    index: 1,
    title: "第1话 来自意大利的家庭教师",
    publishedAt: "2026-08-01",
    views: "128.6万",
    content: [
      "并盛中学的初二学生沢田纲吉,是个连作业都完不成、被人欺负也不敢还口的「废柴阿纲」。他暗恋着同班的笹川京子,却连打个招呼都要鼓起半天的勇气。",
      "这天放学回家,纲吉的房间里突然冒出一股烟。烟雾散去,一个穿着黑色西装、戴着礼帽的婴儿正坐在他的床上,用奶声奶气的意大利腔自我介绍:「我是里包恩,从今天起就是你的家庭教师了。」",
      "原来,纲吉是意大利黑手党彭格列家族第十代首领的候选人,而这个婴儿正是家族派来的「杀手家庭教师」。里包恩掏出一把手枪,对着纲吉开了一枪,一颗「死气弹」正中他的心脏。",
      "奇迹发生了——死气弹并不会要人命,反而会让人在临终前把「后悔的事情」燃烧殆尽,爆发出不可思议的力量。纲吉的头上燃起火焰,用惊人的速度完成了平时打死都做不到的倒立冲刺,在全校同学面前威风了一回。",
      "然而火焰散去,纲吉又变回了那个被嘲笑的废柴。里包恩却满意地点点头:「果然没找错人,你的潜力大得惊人。」从这天起,纲吉平静的日常彻底结束,属于彭格列的波澜壮阔的故事,才刚刚拉开序幕。",
    ],
  },
  {
    id: "chap-hr-002",
    mangaId: "hitman-reborn",
    index: 2,
    title: "第2话 死气弹与倒立冲刺",
    publishedAt: "2026-08-03",
    views: "98.2万",
    content: [
      "死气弹事件之后,纲吉以为生活能恢复平静,但里包恩显然不是这么想的。他制定了「成为合格首领特训计划」,而第一项训练竟然是——当着全校师生的面完成倒立绕学校一圈。",
      "纲吉自然一万个不愿意,可里包恩的枪从不给人商量的余地。又是一声枪响,纲吉带着满头的火焰冲了出去,速度之快甚至掀起了阵阵气浪,连路过的风纪委员长云雀恭弥都露出了感兴趣的表情。",
      "训练结束后,里包恩提出了新的任务:「你的第一个目标,是让班上的转学生顺利融入班级。」纲吉这才知道,自己已经被卷入了一场看不见的家族试炼——每一件看似普通的小事,都是成为首领的必修课。",
      "夜晚,纲吉躺在床上回想起这一天,苦笑里带着一点点说不清的期待。也许,他的人生真的要在这个婴儿的手上,彻底翻篇了。",
    ],
  },
  {
    id: "chap-hr-003",
    mangaId: "hitman-reborn",
    index: 3,
    title: "第3话 狱寺隼人来袭",
    publishedAt: "2026-08-05",
    views: "105.4万",
    content: [
      "一个自称「彭格列第十代首领左右手」的银发少年转入了并盛中学。他叫狱寺隼人,腰间别着炸药,一言不合就要和人动手,是个危险又狂热的家伙。",
      "狱寺的崇拜对象是纲吉——他认定拥有死气火焰的纲吉就是彭格列的继承者,死缠烂打要当纲吉的「左右手」。而纲吉只觉得这个满身火药味的新同学烦得不行。",
      "直到一次街头冲突,狱寺为了保护纲吉挺身而出,引爆了身上的炸药。硝烟散去,他一身狼狈却笑着看向纲吉:「第十代首领,我绝不会让任何人伤害你。」",
      "纲吉看着这个笨拙又倔强的少年,第一次觉得「彭格列」这三个字有了真实的温度。里包恩在一旁悄悄弯起嘴角:第一步,已经迈出去了。",
    ],
  },
  {
    id: "chap-hr-004",
    mangaId: "hitman-reborn",
    index: 4,
    title: "第4话 山本武与棒球",
    publishedAt: "2026-08-08",
    views: "91.7万",
    content: [
      "棒球天才山本武是学校里的人气王,开朗阳光,笑容清爽。里包恩一眼就相中了他:「这个人的剑术天赋,放在黑手党里也是顶尖的。」",
      "纲吉的任务,是说服山本加入彭格列的阵营。可山本对黑手党毫无兴趣,他只想打棒球。纲吉笨拙地陪他练习,一次次被球砸中,却始终没有放弃。",
      "在一次意外中,山本为了保护被不良少年围堵的纲吉,第一次挥出了手中的「剑」。那一刻,山本武终于意识到,自己骨子里其实渴望着更加炽热的战场。",
      "「以后就拜托你了,棒球笨蛋。」纲吉揉着淤青的脸笑出来。山本愣了愣,随即露出招牌的灿烂笑容:「啊,交给我吧,第十代首领。」",
    ],
  },
  {
    id: "chap-hr-005",
    mangaId: "hitman-reborn",
    index: 5,
    title: "第5话 云雀恭弥与风纪",
    publishedAt: "2026-08-10",
    views: "112.3万",
    content: [
      "并盛中学最强的人,是风纪委员长云雀恭弥。他孤高、好斗、讨厌一切群聚,却以一己之力统治着整座校园。里包恩对他的评价只有两个字:「危险。」",
      "纲吉倒霉地在走廊上撞见了云雀。云雀歪着头看了他几秒,云雀的浮萍拐就贴上了纲吉的脸:「草食动物,你身上的味道……不太对劲。」",
      "一场混乱的追逐战就此展开。纲吉被里包恩逼着硬着头皮应战,死气火焰第一次在云雀面前燃起。云雀的眼睛亮了——他找到了一个能让自己稍微提起兴致的「猎物」。",
      "「我记住你了,草食动物。」云雀留下一句话,转身离去。纲吉瘫坐在地,心有余悸地想:这个人,以后真的会是自己的伙伴吗?",
    ],
  },
  {
    id: "chap-hr-006",
    mangaId: "hitman-reborn",
    index: 6,
    title: "第6话 黑曜战,六道骸",
    publishedAt: "2026-08-14",
    views: "156.9万",
    content: [
      "并盛中学的平静被彻底打破。来自黑曜乐园的转学生们接连袭击并盛的学生,而幕后黑手,是拥有「六道轮回」能力的危险人物——六道骸。",
      "六道骸戴着蓝色的长发,右眼瞳孔中跳动着数字,是里包恩口中「绝对不能招惹的敌人」。他盯上了纲吉,宣称要夺取彭格列第十代首领的身体。",
      "为了保护同伴,纲吉第一次主动点燃了死气火焰。狱寺、山本、云雀相继赶到,一场发生在黑曜乐园的混战正式打响。纲吉的火焰在黑暗中越烧越旺,仿佛在回应他心中决意守护的执念。",
      "「我并不是为了当什么首领……我只是,不想看到身边的人受伤而已。」纲吉的声音回荡在废墟之间,那一瞬间,所有人都看见了他眼里的光。",
      "里包恩站在远处,帽檐下的嘴角微微上扬。废柴阿纲终于找到了属于自己的火焰。而真正的试炼,才刚刚开始。敬请期待《家庭教师》后续章节!",
    ],
  },
];